if((typeof Shopify) === 'undefined'){ window.Shopify = {}; }
if((typeof Shopify.getCart) === 'undefined'){
  Shopify.getCart = function(callback, cart){
    if(!cart){
      return jQuery.getJSON('/cart.js', function(cart, textStatus, xhr){
        if((typeof callback) === 'function'){
          callback(cart, textStatus, xhr);
        } else if(typeof Shopify.onCartUpdate === 'function'){
          Shopify.onCartUpdate(cart);
        }
      });
    } else {
      if((typeof callback) === 'function'){
        callback(cart);
      } else if(typeof Shopify.onCartUpdate === 'function'){
        Shopify.onCartUpdate(cart);
      }
    }
  };
}
  
  
/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsAjaxCart = {
    init: function ($section) {

      // Add settings from schema to current object
      Shopify.theme.jsAjaxCart = $.extend(this, Shopify.theme.getSectionData($section));

      if (isScreenSizeLarge() || this.cart_action == 'drawer') {
        this.initializeAjaxCart();
      } else {
        this.initializeAjaxCartOnMobile();
      }
      
       this.updateAjaxUpsellVariant = function (selectElement) {
           const selectedValue = selectElement.value;
       if (!selectElement) {         
          return;
        }else{           
         const SelectParent = selectElement.closest('.ajax-cart__upsell-product');
         const GetATCBtn = SelectParent.querySelector('.ajax-submit.action_button');
         GetATCBtn.setAttribute('data-id', selectedValue);
        }
          
      }

      if (this.cart_action == 'drawer') {

        this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

        $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
          e.preventDefault();
          Shopify.theme.jsAjaxCart.showDrawer();

          return false;
        });

      } else if (this.cart_action == 'mini_cart') {
        this.showMiniCartOnHover();
      }

      $(document).on('click', '.ajax-submit', function (e) {
        e.preventDefault();
        //alert("addupsell");
        const $addToCartForm = $(this).closest('form');
        Shopify.theme.jsAjaxCart.addToCart($addToCartForm);
    
        try {
          window._renderEcodrive();
        } catch (error) {
          console.error("An error occurred while executing window._renderEcodrive()");
        }
        return false;
      });

      $(document).on('click', '[data-ajax-cart-delete]', function (e) {
        e.preventDefault();
        const lineID = $(this).parents('[data-line-item]').data('line-item');
        Shopify.theme.jsAjaxCart.removeFromCart(lineID);

        if (Shopify.theme.jsCart) {
          Shopify.theme.jsCart.removeFromCart(lineID);
        }

        return false;
      });

      $(document).on('click', '[data-ajax-cart-close]', function (e) {
        e.preventDefault();
        Shopify.theme.jsAjaxCart.hideDrawer();
        Shopify.theme.jsAjaxCart.hideMiniCart();

        return false;
      });
      // $(document).on('click', 'button.nosto-btn', function (e) {
      //   e.preventDefault();
      //   //Shopify.theme.jsAjaxCart.showDrawer();
      //   Shopify.theme.jsAjaxCart.updateView(false);
      //   return false;
      // });

    },
    showMiniCartOnHover: function () {
      const $el = $('[data-ajax-cart-trigger]');

      $el.hover(function () {
        if (Shopify.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
          $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
        } else {
          $el.addClass('show-mini-cart');
        }
      }, function () {
        $el.removeClass('show-mini-cart');
      });
    },
    hideMiniCart: function () {
      if (this.cart_action != 'mini_cart') return false;
      const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
      $el.removeClass('show-mini-cart');
    },
    toggleMiniCart: function () {
      const $el = $('.mobile-header [data-ajax-cart-trigger]');

      // Removes url to the cart page so user is not redirected
      $el.attr('href', '#');

      $el.off('touchstart').on('touchstart', function (e) {
        // If user clicks inside the element, do nothing
        if (e.target.closest('[data-ajax-cart-mini_cart]')) {
          return;
        }

        // Loads content into ajaxCart container for mobile header
        Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile();

        // If user clicks outside the element, toggle the mini cart
        $el.toggleClass('show-mini-cart');
      });
    },
    showDrawer: function () {
      if (this.cart_action != 'drawer') return false;
      this.ajaxCartDrawer.addClass('is-visible');
      document.body.classList.add('is-visible');
      $('.ajax-cart__overlay').addClass('is-visible');
      try {
        window._renderEcodrive();
      } catch (error) {
        console.error("An error occurred while executing window._renderEcodrive()");
      }
    },
    hideDrawer: function () {
      if (this.cart_action != 'drawer') return false;
      this.ajaxCartDrawer.removeClass('is-visible');
      $('.ajax-cart__overlay').removeClass('is-visible');
       document.body.classList.remove('is-visible');
    },
    removeFromCart: function (lineID, callback) {
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=0&line=' + lineID,
        dataType: 'json',
        success: function (cart) {
          Shopify.getCart(function(cart){
            Shopify.theme.jsAjaxCart.updateView(false);
          }.bind(this));
        },
        error: function (XMLHttpRequest, textStatus) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;

        }
      });
    },
    initializeAjaxCart: function () {  
      Shopify.theme.asyncView.load(
        Shopify.routes.cart_url, // template name
        'ajax', // view name (suffix)
      )
        .done(({ html, options }) => {

          $('.JsAjaxDesktop [data-ajax-cart-content]').html(html.content);

          // Converting the currencies
          if (Shopify.theme.currencyConverter) {
            Shopify.theme.currencyConverter.convertCurrencies();
          }

        })
        .fail(() => {
          // some error handling
        });
    },
    initializeAjaxCartOnMobile: function () {

      this.toggleMiniCart();

      Shopify.theme.asyncView.load(
        Shopify.routes.cart_url, // template name
        'ajax', // view name (suffix)
      )
        .done(({ html, options }) => {

          $('.mobile-header [data-ajax-cart-content]').html(html.content);

        })
        .fail(() => {
          // some error handling
        });
    },
    addToCartFromDrawer: function (e) {
      let _self = this
      const $addToCartButton = $(e)
      console.log($addToCartButton)
      if (!$addToCartButton.length || !$addToCartButton.data('id')) { return; }
      $addToCartButton.addClass('is-loading');

      let data = {
        id: $addToCartButton.data('id'),
        quantity: 1,
      }
      console.log(data, $addToCartButton)
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function (cart) {
          $addToCartButton.removeClass('is-loading');
          if(!_self.ajaxCartDrawer.hasClass('is-visible')){
            Shopify.theme.jsAjaxCart.showDrawer();
          }
          Shopify.theme.jsAjaxCart.updateView(false);
        },
        error: function (XMLHttpRequest, textStatus) {
          $addToCartButton.removeClass('is-loading');
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
        }
      });
    },
    addToCart: function ($addToCartForm) {
      const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');

      let maxQuantity = parseInt($addToCartForm.find('.purchase-details').data('max-quantity'));
      
      if(maxQuantity){
        let productID = $addToCartForm.find("[name='product-id']").val();
        let productAvailabilityCheck = $('div:not(.header-cart) .theme-ajax-cart .ajax-cart__form').find('[data-product-id="'+productID+'"]');
        let qtySum = 0;
        productAvailabilityCheck.each((item, el) => {
          let qty = parseInt($(el).find(".quantity-wrapper .quantity-input").val());
           qtySum += qty;
        });

        if(qtySum >= maxQuantity) {
          let productName = $addToCartForm.closest(".product__information").find(".product_name").text();
          let cartWarning = `<p class="quantity-warning__message animated bounceIn" style="color: rgb(238, 68, 46); margin-top: 15px;">You can only add ${maxQuantity} ${productName} to the cart.</p>`;
          $addToCartForm.find('.quantity-warning').html(cartWarning).show(0).delay(6000).hide(0); ;
          return false;
        }
        
      }

      $addToCartForm.removeClass('shopify-product-form--unselected-error');

      if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
        const cartWarning = `<p class="cart-warning__message animated bounceIn">${Shopify.translation.select_variant}</p>`;

        $('.warning').remove();

        $addToCartForm
          .addClass('shopify-product-form--unselected-error')
          .find('.cart-warning')
          .html(cartWarning)
          .show();

        $addToCartBtn
          .removeAttr('disabled')
          .removeClass('disabled');

        $addToCartBtn.find('.icon')
          .removeClass('zoomOut')
          .addClass('zoomIn');

        $addToCartBtn
          .find('span:not(.icon)')
          .text($addToCartBtn.data('label'))
          .removeClass('zoomOut')
          .addClass('zoomIn');
      } else {
        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: $addToCartForm.serialize(),
          beforeSend: function () {
            $addToCartBtn
              .attr('disabled', 'disabled')
              .addClass('disabled');

            $addToCartBtn.find('span')
              .removeClass("fadeInDown")
              .addClass('animated zoomOut');
          },
          success: function (product) {

            let $el = $('[data-ajax-cart-trigger]');

            $addToCartBtn
              .find('.checkmark')
              .addClass('checkmark-active');

            function addedToCart() {

              if (!isScreenSizeLarge()) {
                $el = $('.mobile-header [data-ajax-cart-trigger]');
                Shopify.theme.scrollToTop($el);
              } else {
                $el = $('[data-ajax-cart-trigger]');
              }

              $el.addClass('show-mini-cart');

              $addToCartBtn.find('span')
                .removeClass('fadeInDown');
            }

            window.setTimeout(function () {
              $addToCartBtn
                .removeAttr('disabled')
                .removeClass('disabled');

              $addToCartBtn.find('.checkmark')
                .removeClass('checkmark-active');

              $addToCartBtn.find('.text, .icon')
                .removeClass('zoomOut')
                .addClass('fadeInDown');

              $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);

            }, 1000);

            Shopify.getCart(function(cart){
              Shopify.theme.jsAjaxCart.showDrawer();
              Shopify.theme.jsAjaxCart.updateView(false);
            }.bind(this));

            if (Shopify.theme.jsCart) {
              $.ajax({
                dataType: "json",
                async: false,
                cache: false,
                dataType: 'html',
                url: "/cart",
                success: function (html) {
                  const cartForm = $(html).find('.cart__form');
                  $('.cart__form').replaceWith(cartForm);

                }
              });
            }

          },
          error: function (XMLHttpRequest) {
            let response = eval('(' + XMLHttpRequest.responseText + ')');
            response = response.description;

            const cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;

            $('.warning').remove();

            $addToCartForm
              .find('.cart-warning')
              .html(cartWarning)
              .show();

            $addToCartBtn
              .removeAttr('disabled')
              .removeClass('disabled');

            $addToCartBtn.find('.icon')
              .removeClass('zoomOut')
              .addClass('zoomIn');

            $addToCartBtn
              .find('span:not(.icon)')
              .text($addToCartBtn.data('label'))
              .removeClass('zoomOut')
              .addClass('zoomIn');
          }
        });
      }
    },
    updateView: function (ignoreLabelChange) {

      Shopify.theme.asyncView.load(
        Shopify.routes.cart_url, // template name
        'ajax', // view name (suffix)
      )
        .done(({ html, options }) => {

          if (options.item_count > 0) {
            const itemList = $(html.content).find('.ajax-cart__content');
            const cartDetails = $(html.content).find('.ajax-cart__details-wrapper');
            const total_price = options.total_price

            $('.ajax-cart__content').replaceWith(itemList);
            $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
            $('.ajax-cart__empty-cart-message').addClass('is-hidden');
            $('.ajax-cart__form').removeClass('is-hidden');
            $('[data-ajax-cart-trigger]').addClass('has-cart-count');
            $('[data-bind="itemCount"]').text(options.item_count);

            /* Update shipping indicator asynchronously js */
            
if ($('[data-fs-threshold]').length) {
  const $parent = $('[data-fs-threshold]');
  const $remainingWrapper = $parent.find('.fs-indicator__remaining');
  const $successWrapper = $parent.find('.fs-indicator__success');

  const free_shipping_enable = $('[data-enable-fs]').data('enable-fs');
  const free_express_shipping_enable = $('[data-enable-fes]').data('enable-fes');
  const auto_discount_enable = $('[data-enable-ad]').data('enable-ad');
  const free_gift_enable = $('[data-enable-fg]').data('enable-fg');
  const free_gift_type_enable = $('[data-enable-fg-type]').data('enable-fg-type');

  const free_shipping_threshold = $('[data-free-shipping-threshold]').data('free-shipping-threshold');
  const free_express_shipping_threshold = $('[data-free-express-shipping-threshold]').data('free-express-shipping-threshold');
  const auto_discount_threshold = $('[data-auto-discount-threshold]').data('auto-discount-threshold');
  const free_gift_threshold = $('[data-free-gift-threshold]').data('free-gift-threshold');

  const free_gift_variant_id = $('[data-free-gift-product-id]').data('free-gift-product-id');
  const free_gift_variant_price = $('[data-free-gift-product-price]').data('free-gift-product-price');

  const free_shipping_html_threshold = $('.fs_remaining_html_block').html();
  const free_express_shipping_html_threshold = $('.fes_remaining_html_block').html();
  const auto_discount_html_threshold = $('.ad_remaining_html_block').html();
  const free_gift_html_threshold = $('.fg_remaining_html_block').html();

  const total = options.total_price; // cents

  // Helper to render a single "next target" block
  const renderProgress = (html, threshold) => {
    $("body").find('.fs-indicator__remaining .fs_remaining_html_block').html(html || '');
    const pct = Math.max(0, Math.min(100, (total / threshold) * 100));
    $("body").find('.fs-indicator__remaining .bar').css('width', pct + '%');
    $("body").find('.fs-indicator__remaining [data-bind="remaining-amount"]').text(
      Shopify.formatMoney(Math.max(0, threshold - total))
    );
    $remainingWrapper.removeClass('is-hidden');
    $successWrapper.addClass('is-hidden');
  };

  // 1) Compute independent achievements (based on current total)
  const hasFS  = !!(free_shipping_enable && total >= free_shipping_threshold);
  const hasFES = !!(free_express_shipping_enable && total >= free_express_shipping_threshold);
  const hasAD  = !!(auto_discount_enable && total >= auto_discount_threshold);
  // hasFG is handled after we fetch the cart (we need to exclude the gift price if already in cart)

  // 2) Success message toggles (don’t change your structure)
  const $successMsgs = $("body").find('.fs-indicator__remaining .indicator_success_msg_block');
  $successMsgs.addClass('sucesss_msg_active');
  $successMsgs.find('.freeshipping_success_msg').toggleClass('active_block', hasFS);
  $successMsgs.find('.free_express_shipping_success_msg').toggleClass('active_block', hasFES);
  $successMsgs.find('.auto_discount_success_msg').toggleClass('active_block', hasAD);

  // 3) Choose which single block to show as the "next target" (no sums, strict order)
  // Per your request: prioritize Free Gift first, then Free Shipping, then Express, then Auto Discount
  let shown = false;
  if (free_gift_enable && total < free_gift_threshold) {
    renderProgress(free_gift_html_threshold, free_gift_threshold);
    shown = true;
  } else if (free_shipping_enable && total < free_shipping_threshold) {
    renderProgress(free_shipping_html_threshold, free_shipping_threshold);
    shown = true;
  } else if (free_express_shipping_enable && total < free_express_shipping_threshold) {
    renderProgress(free_express_shipping_html_threshold, free_express_shipping_threshold);
    shown = true;
  } else if (auto_discount_enable && total < auto_discount_threshold) {
    renderProgress(auto_discount_html_threshold, auto_discount_threshold);
    shown = true;
  }
  
  if (!shown) {
    // All enabled thresholds reached – hide “remaining”, show “success”
    $remainingWrapper.addClass('is-hidden');
    $successWrapper.removeClass('is-hidden');
  }   

  // 4) FREE GIFT JSON: add/remove gift independently, excluding its own price once present
  //alert("Free Gift"+ free_gift_type_enable);   
  if(free_gift_type_enable == "product_based" && !free_gift_enable){

      $.ajax({
        dataType: 'json',
        async: true,
        cache: false,
        url: '/cart',
        success: function (response) {
          let foundGift = false;
          let itemFoundGiftEnable = false;
          if (response && response.items && response.items.length) {
            for (let i = 0; i < response.items.length; i++) {
             // console.log(response.items[i]);

                fetch(window.Shopify.routes.root + 'products/'+response.items[i].handle+'.js')
                .then(inner_response => inner_response.json())
                .then(product =>{
                        //console.log("Up data");
                        console.log(product);                    
                        var searchValue = "free_gift_enable";
                        if (product.tags.includes(searchValue)) {
                            itemFoundGiftEnable = true;
                          //  console.log("Found Free Gift Enable");
                        } else {
                          console.log(`${searchValue} is not present in the array.`);
                        }                      
                        //alert('The title of this product is ' + product.title);

                        if (response.items[i].id === free_gift_variant_id) {
                            foundGift = true; 
                          //  alert("Already found"); 
                            //return false;                                                      
                        }

                        if(i == (response.items.length - 1)){
                        //  alert("Last Item = "+itemFoundGiftEnable+"  = "+foundGift);
                            if (itemFoundGiftEnable && !foundGift) {
                             //   alert('Add gift The title of this product is '+itemFoundGiftEnable);                              
                                // ADD gift
                                const formData = {
                                  items: [{ id: free_gift_variant_id, quantity: 1 }]
                                };
                                fetch(window.Shopify.routes.root + 'cart/add.js', {
                                  method: 'POST',
                                  headers: { 'Content-Type': 'application/json' },
                                  body: JSON.stringify(formData)
                                })
                                .then(() => {
                                  Shopify.theme.jsAjaxCart.updateView(true);
                                })
                                .catch((error) => console.error('Free gift add error:', error));   

                            }else if (!itemFoundGiftEnable && foundGift) {
                                $.ajax({
                                  type: 'POST',
                                  url: '/cart/change.js',
                                  data: 'quantity=0&id=' + free_gift_variant_id,
                                  dataType: 'json',
                                  success: function () {
                                    Shopify.theme.jsAjaxCart.updateView(true);
                                    return false;
                                  },
                                  error: function (XMLHttpRequest) {
                                    try {
                                      var resp = JSON.parse(XMLHttpRequest.responseText);
                                      console.error('Free gift remove error:', resp && resp.description);
                                    } catch (e) {}
                                  }
                                });                              
                            }
                        }                      
                }); 

                if (response.items[i].id === free_gift_variant_id) {
                    foundGift = true; 
                   // alert("Outer Already found"); 
                    break;
                }

            }
          }


        }
      });

  }else if (free_gift_enable && free_gift_variant_id) {
    $.ajax({
      dataType: 'json',
      async: true,
      cache: false,
      url: '/cart',
      success: function (response) {
        let foundGift = false;
        if (response && response.items && response.items.length) {
          for (let i = 0; i < response.items.length; i++) {
            if (response.items[i].id === free_gift_variant_id) {
              foundGift = true;
              break;
            }
          }
        }

        // Exclude gift price from eligibility if already in the cart to avoid loop
        const effectiveTotal = foundGift ? (total - (free_gift_variant_price || 0)) : total;
        const eligibleForGift = effectiveTotal >= free_gift_threshold;

        if (eligibleForGift && !foundGift) {
          // ADD gift
          const formData = {
            items: [{ id: free_gift_variant_id, quantity: 1 }]
          };
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
          })
          .then(() => {
            Shopify.theme.jsAjaxCart.updateView(true);
          })
          .catch((error) => console.error('Free gift add error:', error));
        } else if (!eligibleForGift && foundGift) {
          // REMOVE gift
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: 'quantity=0&id=' + free_gift_variant_id,
            dataType: 'json',
            success: function () {
              Shopify.theme.jsAjaxCart.updateView(true);
              return false;
            },
            error: function (XMLHttpRequest) {
              try {
                var resp = JSON.parse(XMLHttpRequest.responseText);
                console.error('Free gift remove error:', resp && resp.description);
              } catch (e) {}
            }
          });
        }
      }
    });
  } else if (!free_gift_enable && free_gift_variant_id) {
    // Safety: if gift feature is disabled, ensure gift is not in the cart
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&id=' + free_gift_variant_id,
      dataType: 'json'
    });
  }
}


          } else {
            $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
            $('.ajax-cart__form').addClass('is-hidden');
            $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
            $('[data-bind="itemCount"]').text('0');


                const total_price = options.total_price;
            
                if ($('[data-fs-threshold]').length) {
                  
                    let free_shipping_html_threshold = $('.fs_remaining_html_block').html();
                  
                    let $parent = $('[data-fs-threshold]');
                    let $remainingWrapper = $parent.find('.fs-indicator__remaining');
                    let $successWrapper = $parent.find('.fs-indicator__success');

                    let fs_threshold = $('[data-fs-threshold]').data('fs-threshold');                
                    let fs_remaining = fs_threshold - total_price;         
                  
                    $remainingWrapper.removeClass('is-hidden');
                    $successWrapper.addClass('is-hidden');            
                    $("body").find('.fs-indicator__remaining .fs_remaining_html_block').html(free_shipping_html_threshold);
                    $remainingWrapper.find('.bar').css('width', 0 + '%');
                    $("body").find('.fs-indicator__remaining [data-bind="remaining-amount"]').text(Shopify.formatMoney(fs_threshold));
                    $("body").find('.fs-indicator__remaining .indicator_success_msg_block').removeClass('sucesss_msg_active');
                    $("body").find('.fs-indicator__remaining .indicator_success_msg_block .freeshipping_success_msg').removeClass('active_block');            
                }


            
          }

          if (Shopify.theme.currencyConverter) {
            Shopify.theme.currencyConverter.convertCurrencies();
          }
          nostojs(api => api
          .createRecommendationRequest()
          .setElements(['minicart-nosto-4'])
          .loadRecommendations());
          try {
            window._renderEcodrive();
          } catch (error) {
            console.error("An error occurred while executing window._renderEcodrive()");
          }
        
        })
        .fail(() => {
          // some error handling
        });
    },
    unload: function ($section) {

      // Clear event listeners in theme editor
      $('.ajax-submit').off();
      $('[data-ajax-cart-delete]').off();
    }
  }

  /******/
})()
  ;